import { BaseRoute } from '@core/routing/helper-components/Routes';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import { Module } from '@modules/admin/types';
import PlaybookPage from './pages/PlaybookPage';

export const playbookRoutes: BaseRoute[] = [
  {
    path: '/playbook',
    component: PlaybookPage,
    title: 'Playbook',
    showInSidebar: true,
    icon: <SettingsSuggestIcon />,
    sidebarText: 'Playbook',
    module: Module.PLAYBOOK,
    requiresView: true,
  },
];
